import { render } from "./roombookingdetails.vue?vue&type=template&id=1d138321"
import script from "./roombookingdetails.vue?vue&type=script&lang=js"
export * from "./roombookingdetails.vue?vue&type=script&lang=js"

import "./roombookingdetails.vue?vue&type=style&index=0&id=1d138321&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__